import { memo } from 'react'
import { Path, Svg } from 'react-native-svg'

interface SvgIconProps {
  color?: string
  size?: number
}

export const SvgHex = memo(({ color = '#7750D4', size = 24 }: SvgIconProps) => (
  <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <Path
      d="M5.46049 0.503658C6.15058 -0.0123906 7.07351 -0.142099 7.87911 0.163743L10.5064 1.16117L13.1381 2.1483C13.9451 2.45099 14.513 3.14327 14.6263 3.9625L14.9959 6.63422L15.377 9.30432C15.4939 10.1231 15.1388 10.945 14.4466 11.4584L12.1889 13.1327L9.93831 14.8157C9.24821 15.3317 8.32529 15.4615 7.51969 15.1556L4.89241 14.1582L2.26068 13.1711C1.45371 12.8684 0.885838 12.1761 0.772511 11.3569L0.402921 8.68513L0.0217666 6.01503C-0.0951067 5.1963 0.259947 4.37431 0.952223 3.86092L3.20991 2.18663L5.46049 0.503658Z"
      fill={color}
    />
  </Svg>
))

SvgHex.displayName = 'SvgHex'
